import {Component, computed, contentChild, input, TemplateRef} from '@angular/core';
import {MultiSelect} from 'primeng/multiselect';
import {TranslatePipe} from '@ngx-translate/core';
import {FloatLabel} from 'primeng/floatlabel';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';

@Component({
  selector: 'elcia-multi-dropdown',
  imports: [
    MultiSelect,
    TranslatePipe,
    FloatLabel,
    ReactiveFormsModule,
  ],
  templateUrl: './multi-dropdown.html',
  styleUrl: './multi-dropdown.scss',
})
export class MultiDropdown<T> {
  items = input.required<T[]>();
  textField = input<string>('name');
  valueField = input<string>('id');
  label = input.required<string>();
  itemTemplate = contentChild<TemplateRef<any>>('item');
  control = input.required<FormControl<unknown[]>>();
  isRequired = computed(() => this.control().hasValidator(Validators.required));
}
